import React, { useMemo } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  CK_CONFIGS,
  sanitizeCkEditorHtml,
  setupCkEditorSanitization,
} from "configs";

/** Stable defaults — inline `config={{}}` from parents remounts CKEditor every render. */
const EMPTY_CK_CONFIG = Object.freeze({});
const VIEW_MODE_CK_CONFIG = Object.freeze({ toolbar: Object.freeze([]) });

const CkEditorField = ({
  data = "",
  onChange,
  config,
  readOnly = false,
  disabled = false,
  token,
  onReady,
  ...rest
}) => {
  const resolvedConfig =
    config ?? (readOnly ? VIEW_MODE_CK_CONFIG : EMPTY_CK_CONFIG);

  const editorConfig = useMemo(
    () => ({
      ...CK_CONFIGS(token ?? localStorage.getItem("token")),
      ...resolvedConfig,
    }),
    [token, resolvedConfig]
  );

  const handleReady = (editor) => {
    setupCkEditorSanitization(editor);
    if (readOnly || disabled) {
      editor.enableReadOnlyMode("view-mode");
    } else {
      editor.disableReadOnlyMode("view-mode");
    }
    onReady?.(editor);
  };

  return (
    <CKEditor
      editor={ClassicEditor}
      config={editorConfig}
      data={sanitizeCkEditorHtml(data)}
      disabled={disabled}
      onChange={(event, editor) => {
        if (!readOnly && !disabled && onChange) {
          const next = sanitizeCkEditorHtml(editor.getData());
          const current = sanitizeCkEditorHtml(data);
          if (next === current) {
            return;
          }
          onChange(next, editor, event);
        }
      }}
      onReady={handleReady}
      {...rest}
    />
  );
};

export default CkEditorField;
